import React from "react";
import { Create, SimpleForm, TextInput, required } from "react-admin";

const CreatePublicProcurementActProcedures = () => {
  return (
    <Create title="Създаване на процедура">
      <SimpleForm>
        <TextInput
          label="Име"
          source="name"
          validate={[required()]}
          multiline
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
};

export default CreatePublicProcurementActProcedures;
